import { useTranslation } from 'react-i18next';
import { AppContext } from '../../services/AppContext';
import { ModalContext } from '../../modal/ModalContext';
import MultiButtons from '../../components/global/MultiButtons';
import SubscriptionPresetEditor from './SubscriptionPresetEditor';
import { React, Fragment, useState, useContext, useEffect } from 'react';
import { DeleteConfirmationModal } from '../../modal/global/DeleteConfirmationModal';

const SubscriptionPresets = () => {
    const { t } = useTranslation();
    const { showModal } = useContext(ModalContext);
    const { apiClient, user, notify } = useContext(AppContext);
    const [subscriptionPresetData, setSubscriptionPresetData] = useState([]);

    const handleAddSubscriptionPreset = async () => {
        const created = await showModal(<SubscriptionPresetEditor />);

        if (created) fetchData();
    };

    const handleEditSubscriptionPreset = async (subscriptionPreset) => {
        const updated = await showModal(<SubscriptionPresetEditor subscriptionPreset={subscriptionPreset} />);

        if (updated) fetchData();
    };

    const handleDelete = async (subscriptionPreset) => {
        const shouldDelete = await showModal(
            <DeleteConfirmationModal subject={subscriptionPreset.name} />
        );

        if (shouldDelete) {
            await apiClient.deleteSubscriptionPreset(subscriptionPreset.id);
            fetchData();
            notify(t('pages.subscriptionPresets.notifications.deleted'), 'success');
        }
    };

    const fetchData = async () => {
        const data = await apiClient.getSubscriptionPresets();

        if (!data.hasErrors) {
            setSubscriptionPresetData(data);
        }
    };

    useEffect(() => {
        if (user.role === 'Admin') fetchData();
    }, []);

    return (
        user.role === 'Admin' && (
            <div>
                <div className="filter-container mg-b-1">
                    <button onClick={handleAddSubscriptionPreset}>
                        {t('pages.subscriptionPresets.actions.add')}
                    </button>
                </div>

                <div className="grid-container-3">
                    <div className="grid-header">
                        <div className="container">
                            {t('pages.subscriptionPresets.headers.name')}
                        </div>
                    </div>
                    <div className="grid-header">
                        <div className="container">
                            {t('pages.subscriptionPresets.headers.tags')}
                        </div>
                    </div>
                    <div className="grid-header">
                        <div className="container">
                        </div>
                    </div>
                    {subscriptionPresetData?.map((subscriptionPreset, index) => (
                        <Fragment key={index}>
                            <div className="grid-item">
                                <div className="container">{subscriptionPreset.name}</div>
                            </div>
                            <div className="grid-item">
                                <div className="container">
                                    {subscriptionPreset.tags?.map((t) => t.name).join(', ') || ''}
                                </div>
                            </div>

                            <MultiButtons>
                                <button
                                    className="background-warning width-100p"
                                    onClick={() => handleEditSubscriptionPreset(subscriptionPreset)}
                                >
                                    {t('pages.subscriptionPresets.actions.edit')}
                                </button>
                                <button
                                    className="background-danger width-100p"
                                    onClick={() => handleDelete(subscriptionPreset)}
                                >
                                    {t('pages.subscriptionPresets.actions.delete')}
                                </button>
                            </MultiButtons>
                        </Fragment>
                    ))}
                </div>
            </div>
        )
    );
};

export default SubscriptionPresets;